import React from "react";
import { dynamicValueType } from "./DynamicValueMod";
import {
  DataKeyIcon,
  ExpressionIcon,
  LiveControlIcon,
  PaperIcon,
  ValueIcon,
} from "../../icons-and-animations/Icons";

export function getDynamicValueTypeIcon(vt: dynamicValueType) {
  let icon;
  switch (vt) {
    case "dataKey": // Data
      icon = <DataKeyIcon />;
      break;
    case "liveControlKey": // Control
      icon = <LiveControlIcon />;
      break;
    case "exposeToPlatform":
      icon = <ValueIcon />;
      break;
    case "value": // Edit
      icon = <ValueIcon />;
      break;
    case "expression": // Code
      icon = <ExpressionIcon />;
      break;
    case "inputName": // Input
      icon = <PaperIcon />;
      break;
  }
  return <div className="panel-icon">{icon}</div>;
}
